module.exports = __webpack_public_path__ + "media/images/countrysquared/kr-b60742b0d5221934ae7f2b4c316a8d5f.svg";